import React, { Fragment, useEffect, useState } from "react";
import { useParams, withRouter } from "react-router-dom";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Container, Grid } from "@material-ui/core";
import DocumentViewer from "./PatientViewer/Documents/DocumentViewer";
import ReferralsViewer from "./PatientViewer/Referrals/ReferralsViewer";
import Layout from "./Layout";
import "../styles/index.css";
import PatientData from "./PatientViewer/PatientData";
import auth from "../utils/auth";
import { patientDataStore } from "../store/PatientDataStore";
import styles from "../styles/viewer.module.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import { routes } from "../Router";
import { PatientTabs } from "./PatientTabs";
import { useFhirReferrals } from "../utils/constants";
import { FhirReferralsViewer } from "./PatientViewer/FhirReferrals";
import { CarePlanViewer } from "./PatientViewer/CarePlans";
import AssessmentsViewer from "./PatientViewer/Assessments/AssessmentsViewer";
import { checkAclValidation } from "../utils/permissions/permission.utils";
import mainAcls from "../utils/permissions/mainAcls";
import FormReferralsViewer from "./PatientViewer/Referrals/FormReferralsViewer";
import useUserContextData from "../hooks/useUserContextData";

const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      input: {
        width: "75%",
      },
      root: {
        width: "75%",
      },
    },
  },
});

const PatientInfo = () => {
  const { patientId, app } = useParams();
  const [patientData, setPatientData] = useState(null);
  const [error, setError] = useState(null);

  const { mrnCodingSystem } = useUserContextData();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await patientDataStore.getPatientData(
          patientId,
          mrnCodingSystem
        );
        setPatientData(data);
      } catch (error) {
        setError(error.message);
      }
    };
    fetchData();
  }, [patientId, mrnCodingSystem]);

  const searchOption = !!app;

  const tabs = [
    ...(checkAclValidation({
      acls: [mainAcls.MAIN.PATIENT.TABS.DOCUMENTS],
    })
      ? [
          {
            label: "Documents",
            routeName: "PATIENT_DOCUMENTS",
            component: <DocumentViewer />,
          },
        ]
      : []),
    ,
    ...(checkAclValidation({
      acls: [mainAcls.MAIN.PATIENT.TABS.ASSESSMENTS],
    })
      ? [
          {
            label: "Assessments",
            routeName: "PATIENT_ASSESSMENTS",
            component: <AssessmentsViewer />,
            show: auth.permissions.isPatientAssessmentsEnabled(),
          },
        ]
      : []),

    ...(checkAclValidation({
      acls: [mainAcls.MAIN.PATIENT.TABS.REFERRALS],
    })
      ? [
          {
            label: "Referrals",
            routeName: "PATIENT_REFERRALS",
            component: useFhirReferrals ? (
              <FhirReferralsViewer showAllReferrals={false} />
            ) : (
              <ReferralsViewer />
            ),
          },
        ]
      : []),
    // ...(checkAclValidation({
    //   acls: [mainAcls.MAIN.PATIENT.TABS.ADVANCED_REFERRALS],
    // })
    //   ? [
    //       {
    //         label: "ADVANCED REFERRALS",
    //         routeName: "PATIENT_ADVANCED_REFERRALS",
    //         component: <FormReferralsViewer />,
    //         show: auth.permissions.isAdvancedReferralsEnabled(),
    //       },
    //     ]
    //   : []),
    ...(checkAclValidation({
      acls: [mainAcls.MAIN.PATIENT.TABS.CASES],
    })
      ? [
          {
            label: "Case",
            routeName: "PATIENT_CAREPLANS",
            component: <CarePlanViewer patientData={patientData} />,
            show: auth.permissions.isPatientCarePlansEnabled(),
          },
        ]
      : []),
  ];

  return (
    <ThemeProvider theme={theme}>
      <Layout
        openFile={false}
        patientData={patientData}
        searchNav={searchOption}
      >
        <Grid item xs={12}>
          <Container className="container-documents">
            {!patientData && !error && (
              <ThemeProvider theme={theme}>
                <Container className={styles.centeredProgress}>
                  <CircularProgress />
                </Container>
              </ThemeProvider>
            )}
            {!patientData && error && (
              <ThemeProvider theme={theme}>
                <Container className={styles.errorContainer}>{error}</Container>
              </ThemeProvider>
            )}
            {patientData && !error && (
              <Fragment>
                <PatientData patientData={patientData} />
                <PatientTabs
                  patientId={patientId}
                  app={app}
                  routes={routes}
                  tabs={tabs}
                />
              </Fragment>
            )}
          </Container>
        </Grid>
      </Layout>
    </ThemeProvider>
  );
};

export default withRouter(PatientInfo);
